import SearchIcon from "components/icons/SearchIcon";
import React, {useEffect, useMemo, useState} from "react";
import {MdChevronLeft, MdChevronRight, MdEdit, MdInfoOutline, MdUpload} from "react-icons/md";
import {useGlobalFilter, usePagination, useSortBy, useTable,} from "react-table";
import {DiAndroid, DiApple} from "react-icons/di";
import {utils, writeFile} from "xlsx";
import axios from "axios";
import {AES, enc} from "crypto-js";
import {useUserAuth} from "../../../../../context/UserAuthContext";
import {MdClose} from "react-icons/md";

function FirmwareUploadStatsTable(props) {
    const {columnsData, tableData} = props;

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    const secretKey = "cromptonssecretkey";
    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const columns = useMemo(() => columnsData, [columnsData]);
    const data = useMemo(() => tableData, [tableData]);

    const tableInstance = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,

        prepareRow,
        nextPage,
        previousPage,
        setPageSize,

        setGlobalFilter,
        state,
    } = tableInstance;

    const {pageSize} = state;
    const currentPage = state.pageIndex; // Page index starts from 0
    const totalPages = Math.ceil(data.length / pageSize);

    let [userAccessLevels, setUserAccessLevels] = useState([])

    let [userEditable, setUserEditable] = useState(false);
    let [acl, setAcl] = useState("")
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [currentNotes, setCurrentNotes] = useState("");


    function convertGMTtoIST(gmtDateTime) {
        // Create a new Date object with the GMT date and time
        const gmtDate = new Date(gmtDateTime);

        // Get the time zone offset for IST
        const istOffset = gmtDate.getTimezoneOffset() + 330; // IST is UTC+5:30

        // Create a new Date object with the IST date and time
        const istDate = new Date(gmtDate.getTime() + istOffset);

        // Format the date in DD/MM/YYYY format
        const dateString = istDate.toLocaleDateString('en-IN', {day: '2-digit', month: '2-digit', year: 'numeric'});

        // Format the time in HH:MM format
        const timeString = istDate.toLocaleTimeString('en-IN', {hour: '2-digit', minute: '2-digit'});


        // Return the IST date and time in DD/MM/YYYY HH:MM format
        // return istDate.toLocaleString('en-IN', {timeZone: 'Asia/Kolkata'});
        // Return both date and time strings as an object
        return {date: dateString, time: timeString};
    }

    function getCurrentDate() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Jan is 0!
        const year = today.getFullYear();

        return `${day}-${month}-${year}`
    }

    function exportUserData() {
        let filteredData

        filteredData = data.map((item) => ({
            DpId: item.dpid,
            Name: item.dpName,
            Type: item.dpType,
            Properties: item.dpProperties
        }));

        let wb = utils.book_new(),
            ws = utils.json_to_sheet(filteredData);
        utils.book_append_sheet(wb, ws, "crompton_dpid_details")
        writeFile(wb, "crompton_dpid_details_" + getCurrentDate() + ".xlsx")
    }

    useEffect(() => {
        setPageSize(5)
    }, []);

    return (
        <div className="h-full w-full">
            {/* Search */}
            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                    Version History
                </h2>
                {/*<button*/}
                {/*    className="border border-[#004c86] rounded-lg px-4 py-2 text-sm font-medium"*/}
                {/*>*/}
                {/*    Send Notification for Version Update*/}
                {/*</button>*/}

                {/*<div className="mb-6 flex items-center justify-center">
                    <select id="productFirmwareDropDown" onChange={handleChangeProductDropDown} key={productName}
                            value={pId}
                            className="mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
                        {
                            productCatalog.map((Val) => {
                                    return (
                                        <option value={Val.productId} key={Val.product}>{Val.product}</option>
                                    )
                                }
                            )
                        }
                        <option value="Daily">Daily</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Monthly">Monthly</option>
                    </select>
                </div>*/}
            </div>
            {/* <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                Version History
            </h2>*/}
            {/*<div className="relative flex items-center justify-between">
                <div
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    className="flex w-[400px] max-w-full items-center rounded-xl p-[8px] pt-[20px]"
                >
                    <div
                        className="flex h-[38px] w-[400px] flex-grow items-center rounded-xl bg-lightPrimary text-sm text-gray-600 dark:!bg-navy-900 dark:text-white">
                        <SearchIcon/>
                        <input
                            type="text"
                            placeholder="Search...."
                            className="block w-full rounded-full bg-lightPrimary text-base text-navy-700 outline-none dark:!bg-navy-900 dark:text-white"
                        />
                    </div>
                </div>
                <button
                    className=" mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white"
                    onClick={exportUserData}
                >
                    Export Data
                </button>
            </div>*/}

            {/* table */}
            <div className="mt-[25px] overflow-x-scroll 2xl:overflow-x-hidden">
                <table {...getTableProps()} className="mt-4 h-max w-full" variant="simple" color="gray-500" mb="24px">
                    <thead className="w-full">
                    {headerGroups.map((headerGroup, index) => (
                        <tr
                            className="items-center border-b border-gray-200 text-base dark:border-white/10"
                            {...headerGroup.getHeaderGroupProps()}
                            key={index}
                        >
                            {headerGroup.headers.map((column, index) => (
                                <th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    className="border-b border-gray-200 pb-[10px] text-start dark:!border-navy-700"
                                    key={index}>
                                    <div className="text-xs font-bold tracking-wide text-gray-600">
                                        {column.render("Header")}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {page.map((row, indexPage) => {
                        prepareRow(row);
                        return (
                            <tr
                                className="border-b border-gray-200 dark:!border-white/10"
                                {...row.getRowProps()}
                                key={indexPage}
                            >
                                {row.cells.map((cell, index) => {
                                    let data = "";
                                    switch (cell.column.Header) {
                                        case "SR":
                                            data = (
                                                <div
                                                    className="flex items-center gap-2"
                                                >
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {(currentPage * pageSize) + (indexPage + 1)}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        /*/!*case "NAME":
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );*!/
                                        break*/
                                        case "VERSION":
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                    <button
                                                        className="ml-1 text-[#004c86] hover:text-[#006fbf]"
                                                        onClick={() => {
                                                            setCurrentNotes(cell.row.original.releaseNotes); // adjust this path if needed
                                                            setShowNotesModal(true);
                                                        }}
                                                        title="View Release Notes"
                                                    >
                                                        <MdInfoOutline className="text-base"/>
                                                    </button>
                                                </div>
                                            );
                                            break;
                                        case "SIZE" :
                                            data = (
                                                <div className="items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                    {/*<p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {splitDpPropertiesString(cell.value)[2]}
                                                    </p>*/}
                                                </div>
                                            );
                                            break
                                        case "CRC":
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        case "ACTIVE":
                                            data = (
                                                <div className="flex items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        case "UPLOAD TIME":
                                            data = (
                                                <div className="items-center gap-2">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {convertGMTtoIST(cell.value).date}
                                                    </p>
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {convertGMTtoIST(cell.value).time}
                                                    </p>
                                                </div>
                                            );
                                            break
                                        case "RELEASE NOTES":
                                            data = (
                                                <button
                                                    className="ml-2 text-[#004c86] hover:text-[#006fbf]"
                                                    onClick={() => {
                                                        setCurrentNotes(cell.value); // adjust path based on your data
                                                        setShowNotesModal(true);
                                                    }}
                                                    title="View Release Notes"
                                                >
                                                    <MdInfoOutline className="text-xl"/>
                                                </button>
                                            );
                                            break

                                        /*case "ACTIONS": {
                                            !userEditable ?
                                                data = (
                                                    <button
                                                        className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600"
                                                        onClick={() => editUserAccess(cell.row.original)}
                                                        id="editButton">
                                                        <MdEdit onClick={() => editUserAccess(cell.row.original)}/>
                                                    </button>
                                                ) :
                                                data = (
                                                    <button
                                                        className="max-h-fit w-full max-w-max cursor-pointer text-xl text-gray-600 grid grid-cols-2 gap-2 items-center"
                                                        id="editButton">
                                                        <MdOutlineSave className="text-green-800 "
                                                                       onClick={() => saveUserAccess(cell.row.original)}/>
                                                        <MdOutlineCancel className="text-red-800"
                                                                         onClick={editingCancel}/>
                                                    </button>
                                                )
                                        }*/
                                    }
                                    return (
                                        <td
                                            {...cell.getCellProps()}
                                            key={index}
                                            className=" sm:text-[14px]"
                                        >
                                            {data}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
            {/* pagination */}
            {!userEditable &&
                <div className=" mt-2 flex h-20 w-full items-center justify-between px-6">
                    {/* left side */}
                    <div className=" flex items-center gap-3">
                        <p className="> Show rows per page text-sm text-gray-700 font-bold dark:text-white">
                            Show rows per page{" "}
                        </p>
                        <select
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            className="h-[32px] w-[75px] rounded-[20px] border border-gray-700 px-2 text-gray-700 font-bold dark:!border-white/10 dark:bg-navy-800 dark:text-white"
                            name=""
                            id=""
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="20">20</option>
                        </select>
                    </div>
                    <div className="flex items-center gap-4">
                        <p className="text-sm font-bold text-gray-700 dark:text-white">
                            Page {currentPage + 1} of {totalPages}
                        </p>
                    </div>
                    {/* right side */}
                    <div className="flex items-center gap-3">
                        {state.pageIndex !== 0 && (
                            <button
                                onClick={previousPage}
                                disabled={state.pageIndex === 0}
                                className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                            >
                                <MdChevronLeft/>
                            </button>
                        )}
                        <p className="text-sm text-gray-700 font-bold dark:text-white ">
                            {currentPage + 1}
                        </p>
                        {state.pageIndex !== totalPages - 1 && (
                            <button
                                onClick={nextPage}
                                disabled={state.pageIndex === totalPages}
                                className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                            >
                                <MdChevronRight/>
                            </button>
                        )}
                    </div>
                </div>
            }
            {showNotesModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="max-w-sm w-[90%] bg-white dark:bg-navy-700 p-5 rounded-xl shadow-xl">
                        <div className="flex justify-between items-center mb-3">
                            <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                                Release Notes
                            </h2>
                            <button onClick={() => setShowNotesModal(false)} title="Close">
                                <MdClose className="text-xl text-gray-600 dark:text-white hover:text-red-600"/>
                            </button>
                        </div>
                        <p className="text-sm text-gray-700 dark:text-white whitespace-pre-line">
                            {currentNotes || "No release notes available."}
                        </p>
                    </div>
                </div>
            )}

            {/*<div*/}
            {/*    className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center backdrop-blur-sm">*/}
            {/*    <div className="bg-white dark:bg-gray-800 w-full max-w-lg rounded-lg p-6">*/}
            {/*        <h2 className="text-lg font-semibold mb-4 dark:text-white text-[#004c86]">*/}
            {/*            Notify Users*/}
            {/*        </h2>*/}

            {/*        /!* 🔍 Search *!/*/}
            {/*        <input*/}
            {/*            type="text"*/}
            {/*            placeholder="Search by mobile number or email address"*/}
            {/*            className="w-full border px-3 py-2 mb-4 rounded dark:bg-gray-700 dark:text-white"*/}
            {/*        />*/}

            {/*        /!* 🧾 Selected Users *!/*/}
            {/*        <div className="mb-4 bg-gray-50 dark:bg-gray-700 p-3 rounded-md">*/}
            {/*            <h3 className="text-sm font-semibold text-[#004c86] dark:text-white mb-2">*/}
            {/*                Selected Users*/}
            {/*            </h3>*/}
            {/*        </div>*/}

            {/*        /!* Footer Actions *!/*/}
            {/*        <div className="mt-6 flex justify-between">*/}
            {/*            <button>*/}
            {/*                Notify Selected*/}
            {/*            </button>*/}

            {/*            <button*/}
            {/*                className="bg-[#0b83b5] hover:bg-green-700 text-white px-4 py-2 rounded"*/}
            {/*            >*/}
            {/*                Notify All*/}
            {/*            </button>*/}

            {/*            <button*/}
            {/*                className="bg-gray-300 dark:bg-gray-600 text-black dark:text-white px-4 py-2 rounded hover:bg-gray-400"*/}
            {/*            >*/}
            {/*                Cancel*/}
            {/*            </button>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    );
}

export default FirmwareUploadStatsTable;

